import React, {Component} from 'react';
import SearchModal from '../pages/SearchModal';
import {Modal} from 'react-bootstrap'; 
import {Link} from 'react-router-dom';  

export default class SecondPage extends Component {
   
   constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      show:false
    
     };
      
  }

  componentDidMount() {
   
    fetch("https://product-dot-is-uk-uat-integration-core.nw.r.appspot.com/v1/market/liveproduct/"+this.props.id, {
      "method": "POST",
      "headers": {
        'Username' : 'vipin',
        'Password':'vipin123#',
        'Authorization':'Basic dmlwaW46dmlwaW4xMjMj',
        'Accept':'application/json',
        'Content-Type':'application/json'
        
      }
    })
      .then((res) => res.json())
      .then((json) => {
        this.setState({
            items: json,
            DataisLoaded: true
        });
      })

    }
   
     handleModal(providerLogoUrl,providerDisplayName,displayName,category,interestRateType,interestPayable,withdrawal,minAgeInYr)
  {
    let listItems = [providerLogoUrl,providerDisplayName,displayName,category,interestRateType,interestPayable,withdrawal,minAgeInYr];
    
   // console.log("data" ,listItems);
  
    this.setState({
      show: !this.state.show,
      providerLogoUrl:listItems[0],
      providerDisplayName:listItems[1],
      displayName:listItems[2],
      category:listItems[3],
      interestRateType:listItems[4],
      interestPayable:listItems[5],
      withdrawal:listItems[6],
      minAgeInYr:listItems[7]

    })

  }


    render(){

     const { DataisLoaded, items,providerLogoUrl,providerDisplayName,displayName,category,interestRateType,interestPayable,withdrawal,minAgeInYr } = this.state;
     
      if (!DataisLoaded) return  <div className="text-align-center">
      <img src={process.env.PUBLIC_URL + '/assets/sites/default/files/loader.gif'} alt="loder_img" className="img-fluid mt-5"/>
      </div> ;

      return (
       <div>

        <SearchModal/> 
        {

          items.resultCount === null || items.products.length ===0 ?  (
         <div className="text-align-center">
          <p>No data found.</p>
         </div>
         ):
            items.products.map((item,i) => ( 
            <div className="container">
           
             <div className="row" key={item.i}>
              <div className="col-md-12">
                <div className="product-detailbox">
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="product-bankimg d-flex align-items-center h-100">
                        <img src={item.providerLogoUrl} alt="product_img" className="img-fluid"/>
                      </div>  
                    </div>
                    <div className="col-sm-10">
                      <h4 className="product-name">{item.providerDisplayName} - {item.displayName}</h4>
                      <ul className="product-tablelist-header">
                        <li>Interest (AER)</li>
                        <li>Rate Type</li>
                        <li>Withhrawal</li>
                        
                      </ul>
                      <ul className="product-tablelist">
                        <li><span>Interest (AER)</span> {item.rateAER}</li>
                        <li><span>Rate Type</span> {item.interestRateType}</li>
                        <li><span>Withhrawal</span> {item.withdrawal}</li>
                        
                      </ul>
                    </div>
                    <div className="col-sm-12">
                      <hr/>
                    </div>
                    <div className="col-6 col-sm-5">
                      <div className="d-flex flex-wrap">
                        <p className="text-left mb-2 mr-2">Open At Online {item.openAtOnline === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Open At Branch {item.openAtBranch === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Open At Post {item.openAtPost === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Open At Phone {item.openAtPhone === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Open At Mobile  {item.openAtMobile === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                      </div>

                    </div>
                    <div className="col-6 col-sm-5">
                     
                       <div className="product-left-brd pl-sm-4">
                       <div className="d-flex flex-wrap">
                        <p className="text-left mb-2 mr-2">Manage At Online {item.manageAtOnline === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Manage At Branch {item.manageAtBranch === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Manage At Post {item.manageAtPost === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Manage At Phone {item.manageAtPhone === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        <p className="text-left mb-2 mr-2">Manage At Mobile {item.manageAtMobile === true  ? <span className="text-success"><i className="far fa-check-circle"></i></span> : <span className="text-danger"><i className="far fa-times-circle"></i></span>}</p>
                        </div>
                      </div>   
                     
                    </div> 

          <div className="col-sm-2">
          <div className="d-flex align-items-center h-100">
          <p  onClick={() => this.handleModal(item.providerLogoUrl,item.providerDisplayName,item.displayName,item.category,item.interestRateType,item.interestPayable,item.withdrawal,item.minAgeInYr)} className="pd-btn">Go & Get it</p>
                    </div>
                    </div>  
                  </div>
                </div>
              </div>
          </div>
      </div>

      ))
    }
     

      <Modal show={this.state.show} onHide={() => this.handleModal()} size="lg">
      <Modal.Header closeButton>
      <div className="row">
      <div className="col-sm-4">
            <img src={providerLogoUrl} alt="product-img" className="img-fluid"/>
      </div>  
      <div className="col-sm-8">  
          <h1 className="modal-product-name">{providerDisplayName} - {displayName}</h1>
       </div>
       </div>
      </Modal.Header>
     
      <Modal.Body>

      <div className="col-sm-12 mt-3">
        <div className="modal-tblbg">
                <table className="table modal-tbl">
                  <tbody>
                    <tr>
                      <td>Category</td>
                      <td><strong>{category}</strong></td>
                    </tr>
                    <tr>
                      <td>Tax-free ISA</td>
                      <td><strong>No</strong></td>
                    </tr>
                    <tr>
                      <td>AER</td>
                      <td><strong>0.05%</strong></td>
                    </tr>
                    <tr>
                      <td>Rate Type</td>
                      <td><strong>{interestRateType}</strong></td>
                    </tr>
                    <tr>
                      <td>Interest Payable</td>
                      <td><strong>{interestPayable}</strong></td>
                    </tr>
                    <tr>
                      <td>Withdrawal</td>
                      <td><strong>{withdrawal}</strong></td>
                    </tr>
                    <tr>
                      <td>Term</td>
                      <td><strong>Instant</strong></td>
                    </tr>   
                    <tr>
                      <td>Auto Update</td>
                      <td><strong>Yes</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>  
              <div className="modal-outline-tblbg">
                <table className="table modal-outline-tbl">
                  <thead>
                    <tr>
                      <th colspan="2">AER/Gross</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                      <td>AER/Gross</td>
                      <td><strong>0.05%/0.05%</strong></td>
                    </tr>
                    <tr>
                      <td>Interest Payable</td>
                      <td><strong>Annually</strong></td>
                    </tr>
                    
                  </tbody>
                </table>    
              </div>  
              <div className="modal-outline-tblbg">
                <table className="table modal-outline-tbl">
                  <thead>
                    <tr>
                      <th colspan="2">Eligibility</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                      <td>Min Age</td>
                      {minAgeInYr ? <td><strong>{minAgeInYr} Year(s)</strong></td> : <td><strong></strong></td>}
                     
                    </tr>
                    <tr>
                      <td>Interest Payable</td>
                      <td><strong>Annually</strong></td>
                    </tr>
                    
                  </tbody>
                </table>    
              </div>  
              <div className="modal-outline-tblbg">
                <table className="table modal-outline-tbl">
                  <thead>
                    <tr>
                      <th colspan="2">Deposit Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                      <td>Additional Deposit</td>
                      <td><strong>Allowed</strong></td>
                    </tr>
                                        
                  </tbody>
                </table>    
              </div>  
             </div>

      </Modal.Body>
      <Modal.Footer>
            <div className="d-flex justify-content-end mt-4">
                <Link to={'/'} className="provider-btn" onClick={() => this.handleModal()}>Go To Provider's Site</Link>
                <Link to={'/'} className="close-btn" onClick={() => this.handleModal()}>Close</Link>
              </div>  

      </Modal.Footer>
    </Modal>
 </div>
        )
    }
}